import clsx from 'clsx';
import React from 'react';

var TUXDialogBaseAction = function TUXDialogBaseAction(_ref) {
  var className = _ref.className,
      text = _ref.text,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: clsx(className, 'truncate rounded'),
    disabled: disabled,
    onClick: onClick
  }, text);
};
var TUXDialogTextAction = function TUXDialogTextAction(_ref2) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'primary' : _ref2$variant,
      text = _ref2.text,
      disabled = _ref2.disabled,
      onClick = _ref2.onClick;
  var classes = clsx("tux-dialog-text-action h-48 w-full block text-center px-8", {
    'primary': 'text-color-TextPrimary H4-SemiBold',
    'secondary': 'text-color-TextSecondary H4-Regular',
    'destructive': 'text-color-Negative H4-SemiBold'
  }[variant]);
  return /*#__PURE__*/React.createElement(TUXDialogBaseAction, {
    className: classes,
    text: text,
    disabled: disabled,
    onClick: onClick
  });
};
var TUXDialogButtonAction = function TUXDialogButtonAction(_ref3) {
  var _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'primary' : _ref3$variant,
      text = _ref3.text,
      disabled = _ref3.disabled,
      onClick = _ref3.onClick;
  var classes = clsx('w-full h-full block text-center px-8', {
    'primary': 'text-color-ConstTextInverse background-color-Primary H4-SemiBold tux-dialog-button-action',
    'secondary': 'text-color-TextTertiary H4-Regular tux-dialog-text-action'
  }[variant]);
  return /*#__PURE__*/React.createElement("div", {
    className: "h-48 px-20 tux-dialog-action-container--button"
  }, /*#__PURE__*/React.createElement(TUXDialogBaseAction, {
    className: classes,
    text: text,
    disabled: disabled,
    onClick: onClick
  }));
};

export { TUXDialogBaseAction, TUXDialogButtonAction, TUXDialogTextAction };
//# sourceMappingURL=TUXDialogAction.js.map
